import React from 'react';
import { motion, useInView } from 'framer-motion';

const WhyDifferent = () => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const features = [
    {
      emoji: '❤️',
      title: 'Real Healing, Not Highlights',
      description: 'We don\'t chase clout. We chase clarity. Every story is unfiltered, uncut, and unforgettable.'
    },
    {
      emoji: '🎤',
      title: 'Truth With Purpose',
      description: 'These aren\'t viral moments. They\'re vital ones — built to make you think and move.'
    },
    {
      emoji: '🔥',
      title: 'Built For Dreamers',
      description: 'For the one building from the ground up. For the one who refuses to quit. This one\'s for you.'
    }
  ];

  return (
    <section className="section py-16 sm:py-20 md:py-24 bg-white" ref={ref}>
      <div className="container px-4">
        <motion.div
          className="text-center mb-12 sm:mb-16"
          initial={{ y: 50, opacity: 0 }}
          animate={isInView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl sm:text-4xl md:text-6xl font-bold text-gray-900 mb-4 sm:mb-6">
            What Makes This Different.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 border border-red-200 hover:border-red-400 shadow-lg hover:shadow-xl transition-all group cursor-pointer"
              initial={{ y: 50, opacity: 0 }}
              animate={isInView ? { y: 0, opacity: 1 } : {}}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              whileHover={{ y: -10 }}
            >
              <div className="text-3xl sm:text-4xl mb-3 sm:mb-4 group-hover:scale-110 transition-transform">
                {feature.emoji}
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4 group-hover:text-red-500 transition-colors">
                {feature.title}
              </h3>
              <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyDifferent;